/**
 * Asynchronously loads the component for TwoFactorAuth
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
